import { render, staticRenderFns } from "./OwnerInfo.vue?vue&type=template&id=75256228&scoped=true&"
import script from "./OwnerInfo.vue?vue&type=script&lang=js&"
export * from "./OwnerInfo.vue?vue&type=script&lang=js&"
import style0 from "./OwnerInfo.vue?vue&type=style&index=0&id=75256228&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75256228",
  null
  
)

export default component.exports